function getActiveSigFitRequestId (sampleId) {
  if (!this.samples) return
  const sample = this.samples[sampleId]
  if (!sample) return
  const { activeSigFitRequestId } = sample
  if (!activeSigFitRequestId) return null
  else return activeSigFitRequestId
}

export default getActiveSigFitRequestId